import { defaultApi } from "@/config/httpClient"
import { getLanguageHeaders } from "@/config/i18n"
import { RegionDto } from "@/generated/openapi"

class RegionsService {
  public getRegions(): Promise<Array<RegionDto>> {
    return defaultApi.getAllRegions(getLanguageHeaders()).then(response => {
      return response.data
    }).catch(err => {
      throw err
    })
  }
}
const regionsService = new RegionsService()
export default regionsService
